import { render, staticRenderFns } from "./storeGood.vue?vue&type=template&id=d08dc3ea&scoped=true&"
import script from "./storeGood.vue?vue&type=script&lang=js&"
export * from "./storeGood.vue?vue&type=script&lang=js&"
import style0 from "./storeGood.vue?vue&type=style&index=0&id=d08dc3ea&prod&lang=less&scoped=true&"
import style1 from "./storeGood.vue?vue&type=style&index=1&id=d08dc3ea&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d08dc3ea",
  null
  
)

export default component.exports